export const servedBillCol =
    [
        // {
        //     title: '转入流水号',
        //     en_title: 'Transfer serial number',
        //     ch_title: '转入流水号',
        //     dataIndex: '转入流水号',
        //     // width: '5rem'
        // },
        // {
        //     title: '转入开票点',
        //     en_title: 'Transfer invoice point',
        //     ch_title: '转入开票点',
        //     dataIndex: '转入开票点',
        //     // width: '5rem'
        // },
        {
            title: '交款人/单位',
            en_title: 'Payer/organization',
            ch_title: '交款人/单位',
            dataIndex: '交款人/单位',
            // width: '5rem'
        },
        // {
        //     title: '交款人类型',
        //     en_title: 'Payer type',
        //     ch_title: '交款人类型',
        //     dataIndex: '交款人类型',
        //     // width: '5rem'
        // },
        {
            title: '交款人手机号或电话号码',
            en_title: 'Payer mobile number or phone number',
            ch_title: '交款人手机号或电话号码',
            dataIndex: '交款人手机号或电话号码',
            // width: '5rem',
        },
        {
            title: '开票日期',
            en_title: 'Invoice date',
            ch_title: '开票日期',
            dataIndex: '开票日期',
            // width: '5rem',
        },
        {
            title: '开票人',
            en_title: 'Invoice issuer',
            ch_title: '开票人',
            dataIndex: '开票人',
            // width: '3rem',
        },
        {
            title: '合计金额',
            en_title: 'Total amount',
            ch_title: '合计金额',
            dataIndex: '合计金额',
            // width: '4rem'
        },
        {
            title: '付款方式',
            en_title: 'Payment method',
            ch_title: '付款方式',
            dataIndex: '付款方式',
            // width: '2rem'
        },
        {
            title: '项目1：转入项目',
            ch_title: '项目1：转入项目',
            en_title: 'Item 1: Transferred Item',
            dataIndex: '项目1：转入项目',
            // width: '3rem'
        },
        {
            title: '项目1：数量',
            en_title: 'Item 1: Quantity',
            ch_title: '项目1：数量',
            dataIndex: '项目1：数量',
            // width: '2rem'
        },
        {
            title: '项目1：收费金额',
            en_title: 'Item 1: Amount Fee',
            ch_title: '项目1：收费金额',
            dataIndex: '项目1：收费金额',
            // width: '5rem'
        },
        {
            title: '备注',
            en_title: 'Remarks',
            ch_title: '备注',
            dataIndex: '备注',
            // width: '2rem'
        },
        {
            title: '交款人地址',
            en_title: 'Payer address',
            ch_title: '交款人地址',
            dataIndex: '交款人地址',
            // width: '7rem'
        },
        {
            title: '交款人邮箱',
            en_title: 'Payer Email',
            ch_title: '交款人邮箱',
            dataIndex: '交款人邮箱',
            // width: '7rem'
        },
        {
            title: '项目1：自定义四',
            en_title: 'Item 1: Custom 4',
            ch_title: '项目1：自定义四',
            dataIndex: '项目1：自定义四',
            // width: '3rem'
        },
        // {
        //     title: '项目1：自定义五',
        //     en_title: 'Item 1: Custom 5',
        //     ch_title: '项目1：自定义五',
        //     dataIndex: '项目1：自定义五',
        //     // width: '3rem'
        // },
        // {
        //     title: '自定义二',
        //     en_title: 'Custom 2',
        //     ch_title: '自定义二',
        //     dataIndex: '自定义二',
        //     // width: '3rem'
        // },
        {
            title: '纳税人识别号',
            en_title: 'TIN',
            ch_title: '纳税人识别号',
            dataIndex: '纳税人识别号',
            // width: '5rem'
        },
        // {
        //     title: '身份证号',
        //     dataIndex: '身份证号',
        //     width: '8rem'
        // },
        {
            title: '项目备注',
            en_title: 'Item Remarks',
            ch_title: '项目备注',
            dataIndex: '项目备注',
            // width: '3rem'
        },
        {
            title: '票据号码',
            en_title: 'Ticket Number',
            ch_title: '票据号码',
            dataIndex: '票据号码',
            // width: '8rem'
        },
        {
            title: '序号',
            en_title: 'S/N',
            ch_title: '序号',
            dataIndex: '序号',
            // width: '6rem'
        },
        //红冲功能用字段
        {
            title: '状态',
            en_title: 'Status',
            ch_title: '状态',
            dataIndex: '状态',
            // width: '3rem',
        },
        {
            title: '关联票据号码',
            en_title: 'Associated Ticket Number',
            ch_title: '关联票据号码',
            dataIndex: '关联票据号码',
            // width: '8rem'
        },
    ];

export const htmlstyle = `
@page {
    margin:0;
}
.print_gap{page-break-before: always;}
@media print{
    .invoice {
  display: flex;
  font-size: 11.25pt;
  line-height: 1.25;
  background-image: url(./images/invoice_bgi.png);
  background-repeat: no-repeat;
  background-size: cover;
  min-width: 675pt ;
  min-height: 300pt;
  position: relative;
}
.invoice .name,
.invoice .address,
.invoice .TIN {
  position: absolute;
  top: 10%;
  left: 15%;
}
.invoice .name {
  top: 27%;
}
.invoice .address {
  top: 34%;
}
.invoice .TIN {
  top: 41%;
}
.invoice .detail-top {
  margin: 6pt 11.25pt;
  display: flex;
  justify-content: space-between;
  color: #000;
  position: absolute;
  top: 53%;
  left: 5%;
  min-width: 375pt;
}
.invoice .detail-top .donate {
  display: flex;
  margin-left: 66pt;/*adjust*/
  align-items: flex-end;
}
.invoice .detail-top .donate .donate-top,
.invoice .detail-top .donate .donate-bot {
  width: 75pt;
  text-align: center;
}
.invoice .detail-top .donate .donate-top {
  border-bottom: 1px solid #000;
}
.invoice .word {
  position: absolute;
  bottom: 1%;
  left: 14%;
  font-size: 10.5pt;
  max-width: 360pt;
  margin-bottom: -6pt;
}
.invoice .number {
  position: absolute;
  top: 15%;
  left: 77%;
  font-size: 13.5pt;
}
.invoice .date {
  position: absolute;
  margin-top:6pt;
  top: 55%;
  left: 78%;
  font-size:18px !important;
}
.htmlstr {
  max-height: 375pt;
}
}
`

export const getHtmlStr = (props) => {
    const record = props.record
    var arr = record['开票日期'].split('-')
    var record_date = arr[1] + '/' + arr[2] + '/' + arr[0]
    // const langValue = useSelector(state=>state.langList.value)
    console.log(props);
    return `<div className='invoice print_gap' id="invoice">
            <div className='left'>
                <div className='top'>
                    <div className='imgbox'>
                        <img src="./images/logo.png" />
                    </div>
                    <div className='address'>
                        <h3>Buddhist Compassion Relief Tzu Chi Foundation Philippines Inc.</h3>
                        <div className='txt'>#76 Cordillera St.,cr.Agno St.,Doña Josefa,Quezon City · Tel.No.:87320001</div>
                        <div className='txt'>E-mail:info@tzuchi.org.ph · Website:www.tzuchi.org.ph</div>
                        <div className='txt'>NON-VAT REG. TIN  004-822-133-00000</div>
                    </div>
                </div>
                <div className='item'>
                    Donor Name : 
                    <span>${record['交款人/单位']}</span>
                </div>
                <div className='item'>
                    Address : 
                    <span> ${record['交款人地址']}</span>
                </div>
                <div className='item'>
                    TIN : 
                    <span>${record['纳税人识别号']}</span>
                </div>
                <div>DONATION DETAILS:</div>
                <div className='detail'>
                    <div className='detail-top'>
                        <div className='relief'>
                            Relief Fund : 
                            <span>${record['用途']} </span>
                        </div>
                        <div className='donate'>
                            <div>Total Donation : </div>
                            <div className='donate-box'>
                                <div className='donate-top'>PHP</div>
                                <div className='donate-bot'>PHP</div>
                            </div>
                        </div>
                    </div>
                    <div className='detail-bot'>
                        Note:
                        <span></span>
                    </div>
                </div>
                <div style={{fontSize:'12px'}}>
                    Jing-Si Aphorism:
                    <span style={{color:'#000',fontSize:'16px'}}>最平常的人最富有。The most ordinary person has the most blessing</span>
                </div>
            </div>
            <div className='right'>
                <h3>OFFICIAL RECEIPT</h3>
                <h3>(EXEMPT)</h3>
                <div className='code1'>${record['票据号码']}</div>
                <div className='code2'>
                    No.<span>${record['票据号码']}</span>
                </div>
                <div className='warninfo'>"THIS DOCUMENT IS NOT VALID FOR CLAIM  OF INPUT TAXES"</div>
                <div style={{fontWeight:700}}>Date Issued:</div>
                <div className='date' style={{fontSize:'18px'}}>${record_date}</div>
            </div>
        </div>`

}